import { useToast } from "@/hooks/use-toast";
import { motion, AnimatePresence } from "framer-motion";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  getToastIcon,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      <AnimatePresence mode="popLayout">
        {toasts.map(function ({
          id,
          title,
          description,
          action,
          variant,
          ...props
        }) {
          const icon = getToastIcon(variant);

          return (
            <Toast key={id} variant={variant} {...props}>
              <div className="flex items-start space-x-3 w-full">
                {icon && (
                  <motion.div
                    initial={{ scale: 0, rotate: -180 }}
                    animate={{ scale: 1, rotate: 0 }}
                    transition={{
                      type: "spring",
                      stiffness: 300,
                      damping: 20,
                      delay: 0.1,
                    }}
                    className="flex-shrink-0 mt-0.5"
                  >
                    {icon}
                  </motion.div>
                )}
                <div className="grid gap-1 flex-1 min-w-0">
                  {title && (
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.2, duration: 0.3 }}
                    >
                      <ToastTitle>{title}</ToastTitle>
                    </motion.div>
                  )}
                  {description && (
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.3, duration: 0.3 }}
                    >
                      <ToastDescription>{description}</ToastDescription>
                    </motion.div>
                  )}
                </div>
              </div>
              {action && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.4, duration: 0.2 }}
                  className="flex-shrink-0"
                >
                  {action}
                </motion.div>
              )}
              <motion.div
                initial={{ opacity: 0, scale: 0.8, rotate: 180 }}
                animate={{ opacity: 1, scale: 1, rotate: 0 }}
                transition={{ delay: 0.5, duration: 0.2 }}
              >
                <ToastClose />
              </motion.div>
            </Toast>
          );
        })}
      </AnimatePresence>
      <ToastViewport />
    </ToastProvider>
  );
}
